<template>
  <form @submit.prevent="handleSubmit">
    <b-row class="m-0 mt-3">
      <b-col md="12" class="mb-3" v-for="(item, index) in multipleSelected" :key="index">
        <div class="border p-3 card-sr-information-form">
          <b-row>
            <b-col lg="12">
              <HeaderDetailItemSR :selectedItem="item" :optionsTaskType="optionsTaskType"
                :optionsDepartment="optionsDepartment" :optionsCategory="optionsCategory"
                :optionsClassification="optionsClassification" :optionsCause="optionsCause"
                :optionsKindTask="optionsKindTask" :editable="true" />
            </b-col>
            <b-col lg="12" class="mt-3">
              <label class="mb-0">Internal Man Power</label>
              <b-form-checkbox name="check-button" switch v-model="item.is_internal">
              </b-form-checkbox>
            </b-col>
            <b-col md="12">
              <b-collapse v-model="item.is_internal" :id="`collapse_is_man_power` + index">
                <ListInternalManPower class="mb-3" @onAdd="(value) => onAddManpower(item, value)"
                  @onDelete="(val) => onDeleteManpower(item, val)" :data="item.internal_manpower" :item_id="item.id"
                  createAble />
              </b-collapse>
            </b-col>
            <b-col lg="12" class="mt-3">
              <label class="mb-0">Sub Contractor</label>
              <b-form-checkbox v-model="item.is_subkon" switch>
              </b-form-checkbox>
            </b-col>
            <b-col md="12">
              <b-collapse :key="`collapse_is_sub_con` + index" v-model="item.is_subkon"
                :id="`collapse_is_sub_con` + index">
                <ListSubContractor class="mb-3" :data="item.subcons" @addData="(value) => onAddSubcon(item, value)"
                  @onDelete="(idx) => handleDeleteSubcon(idx, item)"
                  @editData="(idx, value) => onEditSubcon(item, idx, value)" createAble :item_id="item.id" />
              </b-collapse>
            </b-col>
          </b-row>
        </div>
      </b-col>
      <b-col class="my-3 d-flex justify-content-end">
        <b-button type="button" variant="outline-primary" class="mr-2" @click="$emit('close')">Close Review</b-button>
        <b-button v-if="!loading" type="submit" variant="primary">Save Review</b-button>
        <b-button v-else type="button" variant="primary">
          <b-spinner small class="mr-2"></b-spinner> Loading...
        </b-button>
      </b-col>
    </b-row>
  </form>
</template>

<script>
import { srActions } from '@/src/Utils/helper'
import ListInternalManPower from './ListInternalManPower.vue'
import ListSubContractor from './ListSubContractor.vue'
import moment from '@/node_modules/moment/moment'
import HeaderDetailItemSR from './HeaderDetailItemSR.vue'

export default {
  name: 'FormItemSR',
  components: {
    ListInternalManPower,
    ListSubContractor,
    HeaderDetailItemSR,
  },
  props: {
    formId: null,
    selectedItem: {
      type: Object,
      default: () => { },
    },
    optionsTaskType: {
      type: Array,
      default: () => [],
    },
    optionsDepartment: {
      type: Array,
      default: () => [],
    },
    optionsCategory: {
      type: Array,
      default: () => [],
    },
    optionsClassification: {
      type: Array,
      default: () => [],
    },
    optionsCause: {
      type: Array,
      default: () => [],
    },
    optionsKindTask: {
      type: Array,
      default: () => [],
    },
    multipleSelected: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    ...srActions,
    async onSaveReviewRepair() {
      try {
        const user_id = JSON.parse(localStorage.getItem('profile')).id
        this.loading = true
        const contents = [...this.multipleSelected]
        const formData = new FormData()
        formData.append('user_id', user_id)
        formData.append(
          'user_name',
          JSON.parse(localStorage.getItem('profile')).userDetail.name
        )
        contents.forEach((item, index) => {
          formData.append(`content[${index}][form_repair_id]`, item.id)
          formData.append(`content[${index}][cost_estimate]`, item.cost_estimate)
          formData.append(`content[${index}][is_internal]`, item.is_internal)
          formData.append(`content[${index}][is_subkon]`, item.is_subkon)
        })

        const reviewItems = contents.flatMap((item) => [...item.internal_manpower, ...item.subcons])
        reviewItems.forEach((item, index) => {
          for (const key in item) {
            if (key == "subkon_file") {
              const subkonFiles = Array.from(item.subkon_file)
              if (subkonFiles.length) {
                subkonFiles.forEach((file, i) => {
                  if (file instanceof File) {
                    formData.append(`review[${index}][${key}]`, file)
                  }
                })
              }
            } else {
              formData.append(`review[${index}][${key}]`, item[key])
            }
          }
        })
        // formData.forEach((value, key) => {
        //   console.log(key, value)
        // })
        const res = await this.setReviewRepair({
          formData,
          id: this.formId,
          params: { user_id },
        })
        if (res.status === 'success') {
          this.$swal(`Berhasil!`, `Review Repair Berhasil.`, 'success')
          this.$emit('refetch')
        }
      } catch (error) {
        console.log(error)
        this.$swal(`Oops!`, `${error?.data?.message}`, 'error')
      }
      this.loading = false
    },
    handleSubmit() {
      if (this.formId) {
        this.onSaveReviewRepair()
      }
    },
    onAddManpower(item, manPowers) {
      item.internal_manpower.push({ ...manPowers })
    },
    onAddSubcon(item, value) {
      item.subcons.push(...value)
    },
    onEditSubcon(item, idx, value) {
      item.subcons[idx] = { ...value }
    },
    onDeleteManpower(item, val) {
      item.internal_manpower = item.internal_manpower.filter((el, idx) => idx !== val)
    },
    handleDeleteSubcon(index, item) {
      item.subcons = item.subcons.filter((el, idx) => idx !== index)
    },
  },
  mounted() { },
}
</script>
<style scoped>
.card-sr-information-form {
  background: #f7f7f7;
  border-radius: 10px;
}

.text-red {
  color: red;
}
</style>
